export class RelatedRemoveCurrentEntry {
  constructor() {
    const currentEntry: Element | null = document.querySelector(`[data-entry-id]`);

    if (!currentEntry) {
      return;
    }

    const relatedEntries: NodeListOf<Element> = document.querySelectorAll('[data-item-id]');

    if (!relatedEntries.length) {
      return;
    }

    relatedEntries.forEach((entry: Element): void => {
      if (entry.getAttribute('data-item-id') === currentEntry.getAttribute('data-entry-id')) {
        const riderSlider: Element | null = document.querySelector('.rider-slider');
        if (riderSlider) {
          entry.parentElement?.parentElement?.remove();
        }

        entry.remove();
      }
    });
  }
}
